import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut as firebaseSignOut,
  onAuthStateChanged,
  User as FirebaseUser,
} from 'firebase/auth';
import { auth } from '@/lib/firebase';
import { createUser, getUser } from './firestore';
import type { User, UserRole } from '@/types';

export const signUp = async (
  email: string,
  password: string,
  name: string,
  role: UserRole = 'sales',
  phone?: string
): Promise<User> => {
  const userCredential = await createUserWithEmailAndPassword(auth, email, password);
  const firebaseUser = userCredential.user;
  
  const user: User = {
    id: firebaseUser.uid,
    email: firebaseUser.email!,
    name,
    role,
    phone: phone || undefined,
    createdAt: new Date(),
  };
  
  await createUser(user);
  return user;
};

export const signIn = async (email: string, password: string): Promise<User> => {
  const userCredential = await signInWithEmailAndPassword(auth, email, password);
  const firebaseUser = userCredential.user;
  
  const user = await getUser(firebaseUser.uid);
  if (!user) {
    throw new Error('User profile not found');
  }
  
  return user;
};

export const signOut = async (): Promise<void> => {
  await firebaseSignOut(auth);
};

export const getCurrentUser = async (): Promise<User | null> => {
  const firebaseUser = auth.currentUser;
  if (!firebaseUser) return null;
  
  return getUser(firebaseUser.uid);
};

export const onAuthChange = (callback: (user: User | null) => void): (() => void) => {
  return onAuthStateChanged(auth, async (firebaseUser: FirebaseUser | null) => {
    if (firebaseUser) {
      const user = await getUser(firebaseUser.uid);
      callback(user);
    } else {
      callback(null);
    }
  });
};
